import * as React from "react";
const SvgFiRrExchange = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-exchange_svg__a)">
      <path d="M23 16H2.681l.014-.014L4.94 13.7a1 1 0 1 0-1.426-1.4l-2.239 2.278c-.163.163-.39.413-.624.676a2.59 2.59 0 0 0 0 3.429c.233.262.461.512.618.67l2.245 2.284a1 1 0 0 0 1.426-1.4L2.744 18H23a1 1 0 0 0 0-2M1 8h20.255l-2.194 2.233a1 1 0 1 0 1.426 1.4l2.239-2.279c.163-.163.391-.413.624-.675a2.59 2.59 0 0 0 0-3.429 17 17 0 0 0-.618-.67L20.487 2.3a1 1 0 0 0-1.426 1.4l2.251 2.29.008.01H1a1 1 0 0 0 0 2" />
    </g>
    <defs>
      <clipPath id="fi-rr-exchange_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrExchange;
